module.exports = __webpack_public_path__ + "static/media/faq-qr.e589598a.svg";